module.exports = __webpack_public_path__ + "static/media/post-event-top.5ee9a9c3.png";